import { findParentNodeClosestToPos, } from "prosemirror-utils";
export const hasType = (node, type) => node.type === type;
export const hasAttr = (node, attr) => { var _a; return Boolean((_a = node.attrs) === null || _a === void 0 ? void 0 : _a[attr]); };
export { isDocEmpty, isDocHtmlEmpty } from "./empty";
export * from "./text";
/**
 * Looks for the deepest wrapper node that is inside the current cursor selection and returns it if found.
 *
 * Just a subset of available node types are considered "wrappers": `blockquote`, `callout`, `code_block`.
 *
 * @param view The EditorView
 * @param type The wrapper type we're interested in.
 * If there's a deeper wrapper node not matching this given type, `null` is returned instead.
 */
export const findWrapperNode = (view, type) => {
    var _a;
    const wrapperTypes = ["blockquote", "callout", "code_block"];
    const { from, to } = view.state.selection;
    let activeNode = null;
    view.state.doc.nodesBetween(from, to, (node, pos) => {
        if (wrapperTypes.includes(node.type.name)) {
            activeNode = { node, pos };
        }
        return true;
    });
    if (!activeNode || ((_a = activeNode.node) === null || _a === void 0 ? void 0 : _a.type) !== type) {
        return null;
    }
    return activeNode;
};
/**
 * Returns nodes, or it's parent element in case of text nodes for proper positioning.
 *
 * @param view The EditorView
 * @param from Number that represents position from selection
 */
export function getTarget(view, from) {
    const { node } = view.domAtPos(from);
    if (node.nodeName === "#text") {
        return node.parentElement;
    }
    return node;
}
/**
 * Iterates over parent nodes starting from the current position, returning the closest node and its start position.
 * Takes into consideration paragraphs, paragraph_smalls and headings.
 *
 * @param state The EditorState
 */
export function getParentNodeClosestToPos(state) {
    const { from } = state.selection;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { paragraph, paragraph_small, heading } = state.schema.nodes;
    const predicate = (node) => [paragraph, paragraph_small, heading].includes(node.type);
    return findParentNodeClosestToPos(state.doc.resolve(from), predicate);
}
/**
 * Recursively find and return a list of nodes from given type.
 */
export function getDocNodeByType(node, type) {
    var _a;
    if (!node) {
        return [];
    }
    const childrenOfType = ((_a = node.content) !== null && _a !== void 0 ? _a : []).flatMap((child) => getDocNodeByType(child, type));
    if (node.type === type) {
        return [node, ...childrenOfType];
    }
    return childrenOfType;
}
